(() => {
  const storefrontRoot = () => window.Shopify?.routes?.root || '/';
  const localizedPath = (path) => {
    const value = String(path || '');
    return `${storefrontRoot()}${value.startsWith('/') ? value.slice(1) : value}`;
  };

  const SET_WORLDS = {
    brotzeit: { label: 'Brotzeit', items: [
      { handle: 'brotzeit-set-home-signature', size: 'Home', edition: 'Signature', parts: '2-teilig' },
      { handle: 'myromy-brotzeit-set-home-coffee', size: 'Home', edition: 'Coffee', parts: '2-teilig' },
      { handle: 'brotzeit-set-family-signature', size: 'Family', edition: 'Signature', parts: '3-teilig' },
      { handle: 'brotzeit-set-family-coffee', size: 'Family', edition: 'Coffee', parts: '3-teilig' }
    ]},
    ofenliebe: { label: 'Ofenliebe', items: [
      { handle: 'ofenliebe-set-home-signature', size: 'Home', edition: 'Signature', parts: '2-teilig' },
      { handle: 'myromy-ofenliebe-set-home-coffee', size: 'Home', edition: 'Coffee', parts: '2-teilig' },
      { handle: 'ofenliebe-set-family-signature', size: 'Family', edition: 'Signature', parts: '3-teilig' },
      { handle: 'ofenliebe-set-family-coffee', size: 'Family', edition: 'Coffee', parts: '3-teilig' },
      { handle: 'ofenliebe-set-family-friends-signature', size: 'Family + Friends', edition: 'Signature', parts: '5-teilig' },
      { handle: 'myromy-ofenliebe-set-family-friends-coffee', size: 'Family + Friends', edition: 'Coffee', parts: '5-teilig' }
    ]},
    grillmeister: { label: 'Grillmeister', items: [
      { handle: 'grillmeister-set-home-signature', size: 'Home', edition: 'Signature', parts: '3-teilig' },
      { handle: 'myromy-grillmeister-set-home-coffee', size: 'Home', edition: 'Coffee', parts: '3-teilig' },
      { handle: 'grillmeister-set-family-signature', size: 'Family', edition: 'Signature', parts: '5-teilig' },
      { handle: 'grillmeister-set-family-coffee', size: 'Family', edition: 'Coffee', parts: '5-teilig' },
      { handle: 'grillmeister-set-family-friends-signature', size: 'Family + Friends', edition: 'Signature', parts: '7-teilig' },
      { handle: 'grillmeister-set-family-friends-coffee', size: 'Family + Friends', edition: 'Coffee', parts: '7-teilig' }
    ]},
    manufaktur: { label: 'Manufaktur', items: [
      { handle: 'manufaktur-set-home-signature', size: 'Home', edition: 'Signature', parts: '4-teilig' },
      { handle: 'myromy-manufaktur-set-home-coffee', size: 'Home', edition: 'Coffee', parts: '4-teilig' },
      { handle: 'manufaktur-set-family-signature', size: 'Family', edition: 'Signature', parts: '6-teilig' },
      { handle: 'manufaktur-set-family-coffee', size: 'Family', edition: 'Coffee', parts: '6-teilig' },
      { handle: 'manufaktur-set-family-friends-signature', size: 'Family + Friends', edition: 'Signature', parts: '10-teilig' },
      { handle: 'manufaktur-set-family-friends-coffee', size: 'Family + Friends', edition: 'Coffee', parts: '10-teilig' }
    ]},
    brick: { label: 'Brick Sets', items: [
      { handle: 'myromy-bbq-brick-mini-brater-duo-2er-set', size: 'BBQ 2er', edition: 'Signature', parts: '2-teilig' },
      { handle: 'myromy-brick-bbq-signature-edition-4er-set', size: 'BBQ 4er', edition: 'Signature', parts: '4-teilig' },
      { handle: 'myromy-brick-classic-bbq-signature-edition-duo-2er-set', size: 'Classic + BBQ', edition: 'Signature', parts: '2-teilig' },
      { handle: 'myromy-brick-bbq-set-2-bricks-coffee', size: 'BBQ 2er', edition: 'Coffee', parts: '2-teilig' },
      { handle: 'myromy-brick-bbq-set-4-bricks-coffee', size: 'BBQ 4er', edition: 'Coffee', parts: '4-teilig' },
      { handle: 'myromy-brick-classic-bbq-mix-set-coffee', size: 'Classic + BBQ', edition: 'Coffee', parts: '2-teilig' }
    ]}
  };

  const runtimeUi = () => window.myromyQ4?.runtimeUi || {};
  const worldLabel = (key) => String(runtimeUi().worlds?.[key] || '');
  const sizeLabel = (raw) => {
    const key = raw === 'Home'
      ? 'home'
      : raw === 'Family'
        ? 'family'
        : raw === 'Family + Friends'
          ? 'friends'
          : raw === 'BBQ 2er'
            ? 'bbq2'
            : raw === 'BBQ 4er'
              ? 'bbq4'
              : raw === 'Classic + BBQ'
                ? 'mix'
                : '';
    return String((key && runtimeUi().sizes?.[key]) || raw || '');
  };

  const SET_LOOKUP = new Map();
  Object.entries(SET_WORLDS).forEach(([key, world]) => world.items.forEach((item) => SET_LOOKUP.set(item.handle, { ...item, worldKey: key })));

  const currentHandle = () => {
    const match = window.location.pathname.match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  };
  const escapeHtml = (value) => String(value).replace(/[&<>'\"]/g, (char) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[char]));
  const productHref = (handle) => {
    const url = new URL(localizedPath(`products/${handle}`), window.location.origin);
    const previewThemeId = new URLSearchParams(window.location.search).get('preview_theme_id');
    if (previewThemeId) url.searchParams.set('preview_theme_id', previewThemeId);
    return `${url.pathname}${url.search}`;
  };
  const currentSet = () => {
    const handle = currentHandle();
    const item = SET_LOOKUP.get(handle);
    return item ? { handle, item, world: SET_WORLDS[item.worldKey] } : null;
  };

  const optimizeResponsiveImages = () => {
    const apply = (selector, sizes) => document.querySelectorAll(selector).forEach((img) => {
      if (img.getAttribute('sizes') !== sizes) img.setAttribute('sizes', sizes);
      if (!img.getAttribute('decoding')) img.setAttribute('decoding', 'async');
    });
    apply('.mse-set-editorial__gallery img', '(max-width: 749px) 100vw, 50vw');
    apply('.mse-set-product-story__visual img', '50vw');
    apply('.mse-world-card__media img', '(max-width: 749px) 100vw, (max-width: 1199px) 50vw, 25vw');
    apply('.mse-product-card__image img', '(max-width: 749px) 100vw, (max-width: 1199px) 50vw, 25vw');
  };

  const mountStickySwitcher = () => {
    if (document.querySelector('[data-mse-q4-set-switcher]')) return;
    const current = currentSet();
    if (!current) return;
    document.body.classList.add('mse-set-pdp');
    const sectionAnchor = document.querySelector('.mse-setworld-nav')?.closest('.shopify-section') || document.querySelector('.shopify-section--main-product');
    if (!sectionAnchor) return;
    const chips = current.world.items.map((item) => {
      const active = item.handle === current.handle;
      const label = `${sizeLabel(item.size)} · ${item.edition}`;
      return `<a class="mse-q4-set-switcher__chip" href="${escapeHtml(productHref(item.handle))}"${active ? ' aria-current="page"' : ''}>${escapeHtml(label)}</a>`;
    }).join('');
    const nav = document.createElement('nav');
    nav.className = 'mse-q4-set-switcher';
    nav.dataset.mseQ4SetSwitcher = '';
    nav.dataset.mseSetSiblings = '';
    const switcherLabel = String(window.myromyQ4?.setSwitcherLabel || '');
    const switcherAriaSuffix = String(window.myromyQ4?.setSwitcherAriaSuffix || '');
    const currentWorldLabel = worldLabel(current.item.worldKey);
    nav.setAttribute('aria-label', [currentWorldLabel, switcherAriaSuffix].filter(Boolean).join(': '));
    nav.innerHTML = `<div class="mse-q4-set-switcher__inner"><span class="mse-q4-set-switcher__label">${escapeHtml(switcherLabel)}</span><div class="mse-q4-set-switcher__track">${chips}</div></div>`;
    if (sectionAnchor.classList.contains('shopify-section--main-product')) sectionAnchor.insertAdjacentElement('beforebegin', nav);
    else sectionAnchor.insertAdjacentElement('afterend', nav);
    const active = nav.querySelector('[aria-current="page"]');
    const track = nav.querySelector('.mse-q4-set-switcher__track');
    if (active && track) requestAnimationFrame(() => { track.scrollLeft = Math.max(0, active.offsetLeft - ((track.clientWidth - active.clientWidth) / 2)); });
  };

  const enhanceFixedAddToCart = () => {
    const current = currentSet();
    if (!current) return;
    document.body.classList.add('mse-set-pdp');
    const quickAdd = document.querySelector('product-quick-add.product-quick-add');
    if (!quickAdd || quickAdd.querySelector('.mse-set-fixed-atc__summary')) return;
    const mobileButtons = quickAdd.querySelector('buy-buttons[class~="sm:hidden"]');
    if (!mobileButtons) return;
    const priceSource = quickAdd.querySelector('.product-quick-add__variant price-list');
    const priceText = priceSource ? priceSource.textContent.replace(/\s+/g, ' ').trim() : '';
    const summary = document.createElement('div');
    summary.className = 'mse-set-fixed-atc__summary';
    const editionPattern = String(window.myromyQ4?.setEditionPattern || '[edition]');
    const editionText = editionPattern.replace('[edition]', current.item.edition);
    const currentWorldLabel = worldLabel(current.item.worldKey);
    summary.innerHTML = `<span class="mse-set-fixed-atc__title">${escapeHtml(currentWorldLabel)} · ${escapeHtml(sizeLabel(current.item.size))}</span><span class="mse-set-fixed-atc__meta">${escapeHtml(editionText)}${priceText ? ` · ${escapeHtml(priceText)}` : ''}</span>`;
    quickAdd.insertBefore(summary, mobileButtons);
  };

  const handleFromLink = (href) => {
    try {
      const url = new URL(href, window.location.origin);
      const match = url.pathname.match(/\/products\/([^/?#]+)/);
      return match ? decodeURIComponent(match[1]) : '';
    } catch (_) {
      return '';
    }
  };

  const enhanceCartSetLines = () => {
    document.querySelectorAll('line-item').forEach((line) => {
      if (line.querySelector('.mse-cart-set-label')) return;
      const link = line.querySelector('.line-item__info a[href*="/products/"]');
      if (!link) return;
      const item = SET_LOOKUP.get(handleFromLink(link.getAttribute('href') || link.href));
      if (!item) return;
      const stack = line.querySelector('.line-item__info .v-stack');
      if (!stack) return;
      const badge = document.createElement('span');
      badge.className = 'mse-cart-set-label';
      const piecesPattern = String(window.myromyQ4?.setPiecesPattern || '[count]');
      const partsCount = String(item.parts || '').match(/\d+/)?.[0] || '';
      const partsText = partsCount ? piecesPattern.replace('[count]', partsCount) : item.parts;
      const setBadgeLabel = String(window.myromyQ4?.setBadgeLabel || 'Set');
      badge.textContent = `${setBadgeLabel} · ${partsText}`;
      stack.prepend(badge);
      const note = document.createElement('span');
      note.className = 'mse-cart-set-note';
      note.textContent = `${worldLabel(item.worldKey)} · ${sizeLabel(item.size)} · ${item.edition}`;
      const priceList = stack.querySelector('price-list');
      if (priceList) priceList.insertAdjacentElement('afterend', note);
      else stack.appendChild(note);
    });
  };

  let dynamicEnhancementScheduled = false;
  const scheduleDynamicEnhancements = () => {
    if (dynamicEnhancementScheduled) return;
    dynamicEnhancementScheduled = true;
    requestAnimationFrame(() => {
      dynamicEnhancementScheduled = false;
      optimizeResponsiveImages();
      enhanceFixedAddToCart();
      enhanceCartSetLines();
    });
  };

  const observedDynamicTargets = new WeakSet();
  const observeDynamicTargets = () => {
    document.querySelectorAll('cart-drawer, cart-notification-drawer, product-quick-add').forEach((target) => {
      if (observedDynamicTargets.has(target)) return;
      observedDynamicTargets.add(target);
      const observer = new MutationObserver(scheduleDynamicEnhancements);
      observer.observe(target, { childList: true, subtree: true });
    });
  };

  const run = () => {
    optimizeResponsiveImages();
    mountStickySwitcher();
    enhanceFixedAddToCart();
    enhanceCartSetLines();
    observeDynamicTargets();
  };

  run();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
  document.addEventListener('shopify:section:load', run);
  document.addEventListener('shopify:section:select', run);
  document.addEventListener('product:rerender', () => window.setTimeout(run, 0));
})();

(() => {

  const ensureBenefitsHeading = () => {
    const section = document.querySelector('[id$="__multi_column_GHCWRB"]');
    if (!section || section.querySelector('[data-myromy-benefits-heading]')) return;
    const grid = section.querySelector('.multi-column');
    if (!grid) return;
    const header = document.createElement('div');
    header.className = 'section-header justify-self-start text-start';
    header.dataset.myromyBenefitsHeading = 'true';
    const benefitsHeading = String(window.myromyQ4?.setBenefitsHeading || '');
    const headingWrap = document.createElement('div');
    headingWrap.className = 'prose';
    const heading = document.createElement('h2');
    heading.className = 'h2';
    if (!benefitsHeading) return;
    heading.textContent = benefitsHeading;
    headingWrap.appendChild(heading);
    header.appendChild(headingWrap);
    grid.insertAdjacentElement('beforebegin', header);
  };


  const runStandardPdpCuration = () => {
    if (!window.location.pathname.startsWith(localizedPath('products/'))) return;
    ensureBenefitsHeading();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', runStandardPdpCuration, { once: true });
  else runStandardPdpCuration();

  document.addEventListener('shopify:section:load', runStandardPdpCuration);
  document.addEventListener('shopify:section:select', runStandardPdpCuration);
})();

(() => {
  const isHome = () => {
    const root = (window.Shopify?.routes?.root || '/').replace(/\/$/, '');
    return window.location.pathname.replace(/\/$/, '') === root;
  };
  const bySuffix = (suffix) => document.querySelector(`[id$="${suffix}"]`);

  const hideFeaturedProductDescriptions = () => {
    if (!isHome()) return;

    [
      '__featured_product_fwLNpV',
      '__featured_product_nR3ALV',
      '__featured_product_9c3kVi'
    ].forEach((suffix) => {
      const section = bySuffix(suffix);
      if (!section) return;

      section.querySelectorAll('[data-block-type="description"]').forEach((block) => {
        block.hidden = true;
        block.setAttribute('aria-hidden', 'true');
        block.style.display = 'none';
      });
    });

    document.documentElement.dataset.myromyHomepageCuration = 'true';
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hideFeaturedProductDescriptions, { once: true });
  else hideFeaturedProductDescriptions();

  document.addEventListener('shopify:section:load', hideFeaturedProductDescriptions);
  document.addEventListener('shopify:section:select', hideFeaturedProductDescriptions);
})();
